import { ArticleParagraph2, Button, Input, Spinner } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import { IconCheck, IconClose } from './icons';
import * as styles from './index.css';
import { EFeedbackComplaint } from '../../../store/complaint/feedback_complaint';
import { isEmail } from '../../../utils/validate';

export interface IComplaintFeedbackBody {
  email: string;
  complaintId: number;
}

export interface IComplaintFeedbackFormStoreProps {
  sendFormStatus: EFeedbackComplaint;
  complaintId?: number;
  userEmail?: string;
  getUserFeedback: boolean;
}

export interface IComplaintFeedbackFormDispatchProps {
  sendComplaintFeedback(body: IComplaintFeedbackBody): Promise<void>;
  statusChanger(status: EFeedbackComplaint): void;
}

export interface IComplaintFeedbackFormOwnProps {
  inPopupRender?: boolean;
  handleOutsideClick(): void;
  userEmail?: string | null;
}

export type TComplaintFeedbackFormProps = IComplaintFeedbackFormStoreProps &
  IComplaintFeedbackFormDispatchProps &
  IComplaintFeedbackFormOwnProps;

export interface IComplaintFeedbackFormState {
  email: string;
  emailError: string;
}

const MAX_EMAIL_LENGTH = 254;

const DEFAULT_ERROR_MESSAGE = 'Не удалось отправить. Попробуйте позже.';
const INVALIDE_EMAIL_ERROR_MESSAGE = 'Некорректный "E-mail"';
const LONG_EMAIL_ERROR_MESSAGE = 'E-mail не может быть более 254 символов';

export class ComplaintFeedbackForm extends React.Component<TComplaintFeedbackFormProps, IComplaintFeedbackFormState> {
  /* istanbul ignore next */
  public state = {
    email: this.props.userEmail || '',
    emailError: '',
  };

  public render() {
    /* istanbul ignore next */
    const { email, emailError } = this.state;
    /* istanbul ignore next */
    const { sendFormStatus, getUserFeedback, inPopupRender } = this.props;

    /* istanbul ignore next */
    const errorMessage = sendFormStatus === EFeedbackComplaint.error ? DEFAULT_ERROR_MESSAGE : '';

    return (
      <div className={classNames(styles['feedback'], inPopupRender && styles['feedback-in-popup'])}>
        {sendFormStatus === EFeedbackComplaint.loading && (
          <div className={styles['preloader-container']}>
            <div className={styles['preloader-item']}>
              <Spinner size={24} />
            </div>
          </div>
        )}
        {!inPopupRender && (
          <button className={styles['feedback-close']} type="button" onClick={this.handleOutsideClick}>
            <IconClose />
          </button>
        )}
        <div className={styles['feedback-title']}>
          <IconCheck />
          <span>
            Спасибо за помощь. Жалоба
            <br />
            принята к рассмотрению
          </span>
        </div>
        {getUserFeedback && (
          <>
            <div className={styles['feedback-body']}>
              Вы можете оставить ваш e-mail, и мы
              <br />
              пришлем вам информацию о нашем решении
              <br />
              по рассмотрению жалобы в случае подтверждения нарушения правил
            </div>
            <form onSubmit={this.handleSendFeedbackForm} className={styles['feedback-form']}>
              <div className={styles['email-input']}>
                <Input
                  data-name="FeedbackEmail"
                  onFocus={this.handleOnFocusField}
                  onChange={this.handleEmailChange}
                  value={email}
                  invalid={Boolean(emailError || errorMessage)}
                  placeholder="Электронная почта"
                />
              </div>
              {Boolean(emailError || errorMessage) && (
                <div className={styles['error-label']}>
                  <ArticleParagraph2 color="error_100">{emailError || errorMessage}</ArticleParagraph2>
                </div>
              )}
              <div>
                <Button size="XS" type="submit">
                  Отправить
                </Button>
              </div>
            </form>
          </>
        )}
      </div>
    );
  }

  /* istanbul ignore next */
  private handleOnFocusField = (event: React.FormEvent<HTMLInputElement>) => {
    event.preventDefault();

    const { statusChanger } = this.props;

    this.setState({ emailError: '' });
    statusChanger(EFeedbackComplaint.default);
  };

  /* istanbul ignore next */
  private handleOutsideClick = () => {
    const { handleOutsideClick, statusChanger } = this.props;

    handleOutsideClick();

    this.setState({
      email: '',
      emailError: '',
    });

    statusChanger(EFeedbackComplaint.default);
  };

  /* istanbul ignore next */
  private handleSendFeedbackForm = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    const { email } = this.state;
    const { complaintId, sendComplaintFeedback, inPopupRender } = this.props;

    if (!complaintId) {
      this.setState({
        emailError: DEFAULT_ERROR_MESSAGE,
      });

      return;
    }

    if (!email) {
      // Если email пустой, просто закрываем попап
      this.handleOutsideClick();

      return;
    }

    if (email && email.length > MAX_EMAIL_LENGTH) {
      this.setState({
        emailError: LONG_EMAIL_ERROR_MESSAGE,
      });

      return;
    }

    if (!isEmail(email)) {
      this.setState({
        emailError: INVALIDE_EMAIL_ERROR_MESSAGE,
      });

      return;
    }

    sendComplaintFeedback({ email, complaintId: complaintId || 123 }).then(() => {
      if (inPopupRender) {
        this.handleOutsideClick();
      }
    });
  };

  private handleEmailChange = (_: React.ChangeEvent<HTMLInputElement>, value: string) =>
    this.setState({ email: value });
}
